import React, { useContext } from "react";
import "./FAQ.css";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FAQdata from "./FAQdata";
import { Helmet } from "react-helmet";

import { AppContext } from "../shared/context/AppContext";

const CATEGORIES = [
  {
    type: "playing",
    title: "Het spelen van de escape room",
    titleEN: "Playing the escape room",
  },
  {
    type: "buying",
    title: "Aankoop van een toegangscode",
    titleEN: "Buying a code",
  },
  { type: "technical", title: "Technische vragen", titleEN: "Technical questions" },
  { type: "other", title: "Overige vragen", titleEN: "Other questions" },
];

function FAQ() {
  const { language } = useContext(AppContext);
  const nl = language === "NL";

  return (
    <main className="page" id="FAQ">
      <Helmet>
        <title>
          {nl
            ? "Veelgestelde vragen | Escape Mystery"
            : "FAQ | Escape Mystery"}
        </title>
      </Helmet>
      <div className="page-intro">
        <h1>{nl ? "Veelgestelde vragen" : "Frequently asked questions"}</h1>
        <p>
          {nl
            ? "Alles over het spelen, kopen en de techniek achter onze escape rooms."
            : "Everything about playing, buying and the tech behind our escape rooms."}
        </p>
      </div>

      <div className="page-content faq-content">
        {CATEGORIES.map((category) => (
          <section className="faq-category" key={category.type}>
            <h2>{nl ? category.title : category.titleEN}</h2>
            {FAQdata.filter((faq) => faq.type === category.type).map(
              (faq) => (
                // <details> is a native, accessible accordion
                <details className="faq-item" key={faq.id} id={`faq${faq.id}`}>
                  <summary>
                    <span>{nl ? faq.question : faq.questionEN}</span>
                    <FontAwesomeIcon
                      className="faq-chevron"
                      icon={faChevronDown}
                    />
                  </summary>
                  <div className="faq-answer">
                    {nl ? faq.answer : faq.answerEN}
                  </div>
                </details>
              )
            )}
          </section>
        ))}

        <div className="faq-contact">
          <h2>{nl ? "Staat je vraag er niet tussen?" : "Can't find your question?"}</h2>
          <p>
            {nl
              ? "Stuur ons een mailtje, we helpen je graag verder:"
              : "Send us an e-mail, we're happy to help:"}{" "}
            <a href="mailto:helpdesk@escapemystery.nl">
              helpdesk@escapemystery.nl
            </a>
          </p>
        </div>
      </div>
    </main>
  );
}

export default FAQ;
